import React from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";

import { NavMenu } from "../NavMenu/NavMenu";
import { AppState } from "../../store/configureStore";
import Sidebar from "../Sidebar";

import "./layout.css";

interface Props {
    children?: React.ReactNode;
}

const Layout = ({ children }: Props) => {
    const { isLoggedIn } = useSelector((state: AppState) => state.users.auth);

    const location = useLocation();

    return isLoggedIn ? (
        <>
            <div className="layout__sidebar-container no-print">
                <Sidebar />
            </div>
            <div className="layout">
                <div className="layout__header-container">
                    <NavMenu />
                </div>
                <div className="layout__body-container">
                    <Outlet />
                </div>

                {location.pathname !== "/FoodOrder" && (
                    <div className="layout__footer-container">
                        <span>&copy;{` ${new Date().getFullYear()} OIXIO Digital AS`}</span>
                    </div>
                )}
            </div>
        </>
    ) : (
        <>{children}</>
    );
};

export default Layout;
